import { render, staticRenderFns } from "./AddStudentAcceptedChannel.vue?vue&type=template&id=75916e9d&scoped=true&"
import script from "./AddStudentAcceptedChannel.vue?vue&type=script&lang=js&"
export * from "./AddStudentAcceptedChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75916e9d",
  null
  
)

export default component.exports